import { Randstad } from './Randstad';
import CustomerDesktopBase from '../CustomerDesktopBase';

export class CustomerDesktopRandstad extends Randstad {

    constructor() {
        super();
        this.setRandstadCustomerColors();
    };

    private setRandstadCustomerColors(): void {
        this.colors.general.primaryColor = '#2175d9';
        this.colors.general.secondaryColor = '#999';
        this.colors.general.tertiaryColor = this.colorPalette.blue;
        this.colors.general.blueDarkColor = this.colorPalette.blueDeep;

        this.colors.hover.primaryHoverColor = this.colorPalette.blueDeep;

        this.colors.text.passedTextColor = this.colorPalette.green;
        this.colors.text.successTextMessage = this.colorPalette.greenActive;
        this.colors.text.errorTextMessage = this.colorPalette.red;

        this.typography.font.family.heading = 'Tahoma-Large, sans-serif';
        this.typography.font.family.buttons = 'Tahoma, Tahoma-Medium';
        this.typography.font.family.handwriting = 'Tahoma';
        this.typography.font.family.table = 'Tahoma-Regular, Tahoma, sans-serif';
        this.typography.font.family.logo = 'Tahoma, sans-serif';

        this.typography.font.title.textTransform = 'lowercase';
        this.typography.button.text.textTransform = 'lowercase';

        this.setDeprecatedRandstadCustomerColors();
    };

    private setDeprecatedRandstadCustomerColors(): void {

        /** @deprecated since version 0.2.*, use hover.primaryHoverColor */
        this.colors.general.primaryHoverColor = this.colorPalette.blueDeep;
        /** @deprecated since version 0.2.*, use hover.secondaryHoverColor */
        this.colors.general.secondaryHoverColor = this.colorPalette.grayDarker;

        /** @deprecated since version 0.2.*, use text.errorTextMessage */
        this.colors.general.errorTextMessage = this.colorPalette.red;
        /** @deprecated since version 0.2.*, use text.successTextMessage */
        this.colors.general.successTextMessage = this.colorPalette.greenActive;
    };
}

const customerDesktopRandstadTheme = CustomerDesktopBase.setShareStyles(new CustomerDesktopRandstad());
export default customerDesktopRandstadTheme;



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Randstad/customer-desktop.ts